import { render, staticRenderFns } from "./MenuItemBoxGallery.vue?vue&type=template&id=9e58a734&"
import script from "./MenuItemBoxGallery.vue?vue&type=script&lang=js&"
export * from "./MenuItemBoxGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports